<template>
  <section
    class="tenant-card"
    @click="onClickTenant(tenantInfo.tenantId)"
  >
    <section class="details">
      <div class="details__name">
        {{ tenantInfo.tenantName }}
      </div>
      <div class="details__description">
        {{ tenantInfo.description }}
      </div>
    </section>
    <section class="logo-section">
      <img
        :src="tenantInfo.logoUrl"
        alt="ikon"
      >
      <BliRadio
        v-model="tenant"
        :value="tenantInfo.tenantId"
        @update:modelValue="handleTenantSelect"
      />
    </section>
  </section>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
    html:not([dark]) {
      @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
      @import './index.scss';
    }
    html[dark] {
      @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
      @import './index.scss';
    }
</style>
